const createSalesMailto = ({ subject, product, accountLabel }) => {
  const body = [
    `Product interest: ${product}`,
    "Agency name:",
    `${accountLabel}:`,
    "Platforms in use (GTM, GA4, paid media):",
    "Primary QA challenge:",
  ].join("\n")

  return `mailto:hello@jarbod.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export const measurementStudioSalesMailto = createSalesMailto({
  subject: "Measurement Studio sales inquiry",
  product: "Measurement Studio",
  accountLabel: "Number of client accounts",
})

export const measurementStudioScaleMailto = createSalesMailto({
  subject: "Measurement Studio Scale inquiry",
  product: "Measurement Studio Scale (coming soon)",
  accountLabel: "Number of client accounts",
})

export const ascTuneUpSalesMailto = createSalesMailto({
  subject: "ASC TuneUp sales inquiry",
  product: "ASC TuneUp",
  accountLabel: "Number of dealership accounts",
})

export const ascTuneUpScaleMailto = createSalesMailto({
  subject: "ASC TuneUp Scale inquiry",
  product: "ASC TuneUp Scale (coming soon)",
  accountLabel: "Number of dealership accounts",
})

